/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Account_SourceInputs */

const vi_shop_account_source = /** @type {(inputs: Shop_Account_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nguồn`)
};

/**

* @param {Shop_Account_SourceInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_account_source = /** @type {((inputs?: Shop_Account_SourceInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Account_SourceInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_account_source(inputs)
});